import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveLockedUserMutation = gql`
   mutation SaveLockedUser($user: UserPostInput!) {
      saveUser(user: $user) {
         userId
         isLocked
      }
   }
`;
